import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import myPicture from '../assets/images/zach2.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={myPicture} alt="Zach Smith" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/zacharyssmith" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/zach-smith/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
          <h1>Zachary Smith</h1>
          <p>Senior Full-Stack Engineer and Technical Lead with 13+ years of consulting experience across banking, government, logistics, and material handling. Expert in Java/Spring Boot microservices, Angular, React, and AWS — owning full project lifecycles from architecture and design through production support. G2O Impact Award winner — the company's highest honor across 300+ employees. Open to full-time engineering roles where I can invest deeply in one team, codebase, and mission.</p>
          <span>Senior Software Engineer | Seattle, Washington | Ohio University - BS CS | <a href="mailto:zs321007@gmail.com">zs321007@gmail.com</a> | On-site, Hybrid, or Remote</span>

          <div className="mobile_social_icons">
            <a href="https://github.com/zacharyssmith" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/zach-smith/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;